import React, {useEffect, useState} from "react";
import 'katex/dist/katex.min.css';
import 'katex/contrib/mhchem';
import katex from "katex";
import classNames from "classnames";

export function CustomLatex({text}) {

    const[display, setDisplay] = useState(false);
    let latex = null

    useEffect(() => {
        setDisplay(text.includes("$$"))
    }, []);


    const latexClass = classNames("__Latex__", {
        "latex-large":text.includes("$$")
    })

    try {
        latex = katex.renderToString(text.replaceAll("$", ""), {displayMode:(display ? "display":""), throwOnError:false});
    }catch (e) {
        console.log(e)
    }

    return (
        <span className={latexClass} dangerouslySetInnerHTML={{ __html: latex }} />
    )

}